"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _framerMotion = require("framer-motion");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _useTheme = _interopRequireDefault(require("@material-ui/styles/useTheme"));

var _desktopMenuItem = _interopRequireDefault(require("./desktopMenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    container: {
      display: "grid"
    },
    containerHorizontal: _defineProperty({
      gridTemplateColumns: "repeat(3, 1fr)"
    }, theme.breakpoints.up("xl"), {
      gridTemplateColumns: "repeat(4, 1fr)"
    }),
    containerVertical: _defineProperty({
      gridTemplateColumns: "repeat(3, 1fr)"
    }, theme.breakpoints.up("xl"), {
      gridTemplateColumns: "repeat(4, 1fr)"
    }),
    block: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(0, 0, 2)
    }
  };
});

var DesktopSubContent = function DesktopSubContent(_ref) {
  var desktopSubContainerLayoutColumn = _ref.desktopSubContainerLayoutColumn,
      submenu = _ref.submenu;
  if (submenu.length === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  var horizontal = /*#__PURE__*/_react.default.createElement(LayoutHorizontal, null, submenu.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(SubItem, {
      key: item.id,
      item: item
    });
  }));

  var vertical = /*#__PURE__*/_react.default.createElement(LayoutVertical, {
    submenu: submenu
  });

  return desktopSubContainerLayoutColumn === "horizontal" ? horizontal : vertical;
};

var LayoutHorizontal = function LayoutHorizontal(props) {
  var css = useStyles();
  var theme = (0, _useTheme.default)();
  var animation = {
    hidden: {
      opacity: 0,
      x: -(theme === null || theme === void 0 ? void 0 : theme.spacing(3))
    },
    visible: function visible() {
      return {
        opacity: 1,
        transition: {
          delay: 0.2
        },
        x: 0
      };
    }
  };
  return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    initial: "hidden",
    animate: "visible",
    variants: animation,
    className: (0, _clsx.default)("menu-01-desktop-container", "menu-01-desktop-container__horizontal", css.container, css.containerHorizontal)
  }, props.children);
};

var LayoutVertical = function LayoutVertical(_ref2) {
  var submenu = _ref2.submenu;
  var css = useStyles();
  var theme = (0, _useTheme.default)();
  var bigScreen = (0, _useMediaQuery.default)(theme.breakpoints.up("xl"));
  var animation = {
    hidden: {
      opacity: 0,
      x: -(theme === null || theme === void 0 ? void 0 : theme.spacing(3))
    },
    visible: function visible() {
      return {
        opacity: 1,
        transition: {
          delay: 0.2
        },
        x: 0
      };
    }
  };
  var items = [];
  var columns = bigScreen ? 4 : 3;
  var counter = 0;

  var _iterator = _createForOfIteratorHelper(submenu),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var column = counter % columns;
      if (!items[column]) items[column] = [];
      items[column].push(item);
      counter++;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    initial: "hidden",
    animate: "visible",
    variants: animation,
    className: (0, _clsx.default)("menu-01-desktop-container", "menu-01-desktop-container__vertical", css.container, css.containerVertical)
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, item.map(function (subItem) {
      return /*#__PURE__*/_react.default.createElement(SubItem, {
        key: subItem.id,
        item: subItem
      });
    }));
  }));
};

var SubItem = function SubItem(_ref3) {
  var _item$icon, _item$items;

  var item = _ref3.item;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("menu-01-desktop-menuitem-block", css.block),
    key: item.id
  }, /*#__PURE__*/_react.default.createElement(_desktopMenuItem.default, {
    icon: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.filename,
    level: 2,
    link: item.link,
    selected: item.selected,
    target: item.target,
    title: item.title
  }), item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.map(function (subItem) {
    var _subItem$icon;

    return /*#__PURE__*/_react.default.createElement(_desktopMenuItem.default, {
      key: subItem.id,
      icon: (_subItem$icon = subItem.icon) === null || _subItem$icon === void 0 ? void 0 : _subItem$icon.filename,
      level: 3,
      link: subItem.link,
      selected: subItem.selected,
      target: subItem.target,
      title: subItem.title
    });
  }));
};

DesktopSubContent.propTypes = {
  desktopSubContainerLayoutColumn: _propTypes.default.string.isRequired,
  submenu: _propTypes.default.array.isRequired
};
var _default = DesktopSubContent;
exports.default = _default;